import styled, { css } from 'styled-components'

const ContentsWrap = styled.div<{ media?: string; option?: string }>`
  ${(props) =>
    props.media === 'pc' &&
    css`
      width: 396px !important;
      margin: 0 auto;
      height: 100%;
    `}

  ${(props) =>
    props.media === 'tablet' &&
    css`
      .gm-control-active {
        &.gm-fullscreen-control {
          display: none;
        }
      }
      .gmnoprint {
        top: 50px !important;
      }
    `}
  ${(props) =>
    props.media === 'mobile' &&
    css`
      min-width: 320px;
      .gmnoprint {
        top: 0;
      }
    `} //gm-style-mtc-bbw
`

export { ContentsWrap }
